import { render } from "./Affectation.vue?vue&type=template&id=22766c83"
import script from "./Affectation.vue?vue&type=script&lang=js"
export * from "./Affectation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__